<h2 md-dialog-title>{{data.title}}</h2>
<div md-dialog-content>{{data.message}}</div>
<div md-dialog-actions>
  <button class="button" (click)="onNoClick()">No</button>
  <button class="button button--secondary" (click)="onYesClick()">Si</button>
</div>
